import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class PdfPageCountService {
  private workerConfigured = false

  /**
   * Reads the number of pages in a PDF file without rendering it. Uses pdf.js,
   * which parses the document's page tree, so this stays cheap even for large
   * board packs. pdf.js is imported dynamically so the (sizeable) library is
   * only fetched when a page count is actually needed, not at app startup.
   */
  async getPageCount(file: File): Promise<number> {
    const { getDocument, GlobalWorkerOptions } = await import('pdfjs-dist')
    if (!this.workerConfigured) {
      // The worker is copied into the assets directory by the build (see the
      // pdfjs-dist asset glob in angular.json). pdf.js loads it as a module worker.
      GlobalWorkerOptions.workerSrc = 'assets/pdfjs/pdf.worker.min.mjs'
      this.workerConfigured = true
    }
    const data = new Uint8Array(await file.arrayBuffer())
    const loadingTask = getDocument({ data })
    const pdf = await loadingTask.promise
    try {
      return pdf.numPages
    } finally {
      await loadingTask.destroy()
    }
  }
}
